import { Grid, Tab } from '@mui/material';

import { PermissionsEnum } from '@/auth/interfaces';
// import {
//   InstalacionesAsignadasTecnicoPage,
//   InstallAsignadaTecnicoOTByState,
// } from '@/erp/tecnico/orden-trabajo/pages';
import {
  EstadosActivacionInstallOTEnumChoice,
  EstadosOrdenTrabajoEnumChoice,
  // EstadosProcesoEnumChoice,
  // ROUTER_PATHS,
  a11yProps,
  gridSizeMdLg12,
  gridSizeMdLg6,
  useCheckPermissions,
  useTabsFormOnly,
} from '@/shared';
import {
  CustomTabPanel,
  FormTabsOnly,
  SingleBoxTableTabsOnly,
  SingleTableBoxScene,
} from '@/shared/components/ui';
// import ActivacionInstalacionByStatePage from '../ActivacionInstalacionByStatePage';
import ActivacionInstalacionPage from '../ActivacionInstalacionPage';
import CustomRangeDate from '@/shared/components/ui/CustomRangeCalendar';
import dayjs from 'dayjs';
import { useState } from 'react';

export type InstalacionesTecnicoPageProps = {};

const ActivacionesInstalacionMainPage: React.FC<
  InstalacionesTecnicoPageProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_view_ordentrabajo);
  const [dateRange, setDateRange] = useState<[string, string]>([dayjs().format('YYYY-MM-DD'), dayjs().add(1, 'week').format('YYYY-MM-DD')]);
  const { handleMethodChange, valueTab } = useTabsFormOnly();

  return (
    <SingleTableBoxScene title={"Activaciones"}>
      <Grid {...gridSizeMdLg12} container item justifyContent="flex-end" alignItems="center">
        <Grid {...gridSizeMdLg6} container item>
          <CustomRangeDate
            // onChange={(val) => {console.log(val)}}
            
            defaultValue={dateRange}
            label="Fecha instalacion"
            onChangeRangeDate={(val) => { setDateRange([dayjs(val[0]).format('YYYY-MM-DD'), dayjs(val[1]).format('YYYY-MM-DD')]); }}
            cleanFilter={() => setDateRange(["",""])}
            // custom_options={{
            //   minDate: "today",
            //   maxDate: dayjs().add(1, 'month').toDate(),
            // }}
          />
        </Grid>
      </Grid>
      <SingleBoxTableTabsOnly>
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="Pendientes" value={1} {...a11yProps(1)} />
          <Tab label="Pendientes Recoordinadas" value={2} {...a11yProps(2)} />
          <Tab label="Gestionadas" value={3} {...a11yProps(3)} />
          <Tab label="Rechazadas" value={4} {...a11yProps(4)} />
        </FormTabsOnly>
      </SingleBoxTableTabsOnly>

      {/* ============ Pendientes ============ */}
      <CustomTabPanel value={valueTab} index={1}>
        <ActivacionInstalacionPage 
          estadoOT={EstadosOrdenTrabajoEnumChoice.EN_ESPERA}
          estadoActivacion={EstadosActivacionInstallOTEnumChoice.EN_ESPERA}
          defaultDateRange={dateRange}
          tipoOrdenServicioExclude="TRASLADO,VISITA"
        />
      </CustomTabPanel>

      {/* ============ Pendientes Recoordinadas ============ */}
      <CustomTabPanel value={valueTab} index={2}>
        <ActivacionInstalacionPage 
          estadoOT={EstadosOrdenTrabajoEnumChoice.ESPERA_RECOORDINADA}
          estadoActivacion={EstadosActivacionInstallOTEnumChoice.EN_ESPERA}
          defaultDateRange={dateRange}
          tipoOrdenServicioExclude="TRASLADO,VISITA"
        />
      </CustomTabPanel>

      {/* ============ Gestionadas ============ */}
      <CustomTabPanel value={valueTab} index={3}>
        <ActivacionInstalacionPage
          estadoActivacion={EstadosActivacionInstallOTEnumChoice.GESTIONADA}
          defaultDateRange={dateRange}
          tipoOrdenServicioExclude="TRASLADO,VISITA"
        />
      </CustomTabPanel>
      {/* ============ Rechazadas ============ */}
      <CustomTabPanel value={valueTab} index={4}>
        <ActivacionInstalacionPage
          enableEdit={false}
          estadoActivacion={EstadosActivacionInstallOTEnumChoice.RECHAZADA}
          defaultDateRange={dateRange}
          tipoOrdenServicioExclude="TRASLADO,VISITA"
        />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );
};

export default ActivacionesInstalacionMainPage;
